import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.25 14C14.8358 14 14.5 14.3358 14.5 14.75C14.5 15.1642 14.8358 15.5 15.25 15.5H18.75C19.1642 15.5 19.5 15.1642 19.5 14.75C19.5 14.3358 19.1642 14 18.75 14H15.25Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.75 3C0.783502 3 0 3.7835 0 4.75V19.25C0 20.2165 0.783502 21 1.75 21H22.25C23.2165 21 24 20.2165 24 19.25V4.75C24 3.7835 23.2165 3 22.25 3H1.75ZM1.5 4.75C1.5 4.61193 1.61193 4.5 1.75 4.5H22.25C22.3881 4.5 22.5 4.61193 22.5 4.75V8.5H1.5V4.75ZM1.5 10V19.25C1.5 19.3881 1.61193 19.5 1.75 19.5H22.25C22.3881 19.5 22.5 19.3881 22.5 19.25V10H1.5Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgCreditCard;
